import { useEffect, useRef, useState, type ReactElement, type ReactNode } from 'react';
import './entity-detail.css';
import '../../shared/ui/list.css';

export function EntityDetailLayout({
  header,
  main,
  sidebar,
}: {
  header: ReactNode;
  main: ReactNode;
  sidebar: ReactNode;
}): ReactElement {
  const scrollRef = useRef<HTMLElement>(null);
  const sidebarRef = useRef<HTMLElement>(null);
  const [sidebarFits, setSidebarFits] = useState(false);
  useEffect(() => {
    const scroll = scrollRef.current;
    const aside = sidebarRef.current;
    if (!scroll || !aside || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(() =>
      setSidebarFits(aside.offsetHeight <= scroll.clientHeight - 40),
    );
    observer.observe(scroll);
    observer.observe(aside);
    return () => observer.disconnect();
  }, []);
  return (
    <main
      ref={scrollRef}
      tabIndex={0}
      className="entity-detail-scroll flex-1 min-h-0 overflow-y-auto crm-checkbox-square"
    >
      <div className="entity-detail-layout">
        <div className="entity-detail-header">{header}</div>
        <section className="entity-detail-main">{main}</section>
        <aside
          ref={sidebarRef}
          className={`entity-detail-sidebar${sidebarFits ? ' is-sticky' : ''}`}
        >
          {sidebar}
        </aside>
      </div>
    </main>
  );
}
